import type { ICommand } from '../../core/interfaces/Command';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import type { IValue } from '@/engine/DataFlow/Graph';
import type { IBaseViewModel } from '@/engine/app/interfaces';
import type { ValueConstructor } from '@/engine/DataFlow/DataFlow';
import type { IIndicationAdder } from '../interfaces';

export class BaseRemoveCommand implements ICommand {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _remover: IRemover;

  protected readonly _viewModel: IBaseViewModel;

  private readonly _modelConstructor: ValueConstructor;

  private _model: IValue | undefined;

  private readonly _adder: IIndicationAdder<IValue>;

  public constructor(
    planningAlgorithm: PlanningAlgorithm,
    remover: IRemover,
    adder: IIndicationAdder<IValue>,
    viewModel: IBaseViewModel,
    constructor: ValueConstructor
  ) {
    this._planningAlgorithm = planningAlgorithm;
    this._remover = remover;
    this._viewModel = viewModel;
    this._modelConstructor = constructor;
    this._adder = adder;
  }

  public execute(): Promise<boolean> {
    this._model = this._planningAlgorithm.getValueStrict(this._viewModel.descriptor, this._modelConstructor);
    this._remover.removeByDescriptor(this._viewModel.descriptor);
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    if (!this._model) {
      throw new Error('Model for undo is undefined.');
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._adder.addIndication(this._model, this._viewModel);

    return Promise.resolve(false);
  }
}
